import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxTargetLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.833 3.39V1.668H9.167V3.39A6.673 6.673 0 0 0 3.39 9.167H1.667v1.666H3.39a6.672 6.672 0 0 0 5.776 5.776v1.724h1.666V16.61a6.672 6.672 0 0 0 5.776-5.776h1.724V9.167H16.61a6.673 6.673 0 0 0-5.776-5.776ZM10 15c-2.757 0-5-2.242-5-5s2.243-5 5-5c2.758 0 5 2.242 5 5s-2.242 5-5 5Z"
	})]
});
export default SvgBxTargetLock;
